import React from "react";
import { Text, View } from "react-native";
import { Input } from "react-native-elements";

const TextInput = ({
  disabled,
  field: { name, onBlur, onChange, value },
  form: { errors, touched },
  icon,
  placeholder,
  width,
  inputStyle,
}) => {
  return (
    <View style={{ width }}>
      <Input
        leftIcon={icon}
        placeholder={placeholder}
        editable={!disabled}
        selectTextOnFocus={!disabled}
        onChangeText={onChange(name)}
        onBlur={onBlur(name)}
        value={value}
        underlineColor="red"
        inputStyle={inputStyle}
      />
      {errors[name] && touched[name] && <Text>{errors[name]}</Text>}
    </View>
  );
};

export default TextInput;
